// Modals close when their full-screen backdrop is clicked. A mouse drag that starts inside a form
// (selecting text, for example) and ends on the backdrop makes the browser fire that click on the
// backdrop, closing the form. This drops exactly that click: the click landed on a full-screen
// fixed element, but the press started on something inside it. A real backdrop click (press and
// release both on the backdrop) is untouched.

let pressTarget = null;

function isBackdrop(el) {
  if (!(el instanceof Element)) return false;
  if (window.getComputedStyle(el).position !== 'fixed') return false;
  const r = el.getBoundingClientRect();
  return r.width >= window.innerWidth * 0.9 && r.height >= window.innerHeight * 0.9;
}

export function installBackdropClickGuard() {
  document.addEventListener('mousedown', (e) => { pressTarget = e.target; }, true);
  document.addEventListener('click', (e) => {
    const started = pressTarget;
    pressTarget = null;
    if (!started || started === e.target) return;
    if (!(e.target instanceof Element) || !e.target.contains(started)) return;
    if (!isBackdrop(e.target)) return;
    e.stopImmediatePropagation();
    e.preventDefault();
  }, true);
}
